import { render, staticRenderFns } from "./time-since.vue?vue&type=template&id=536cdba4&scoped=true&"
import script from "./time-since.vue?vue&type=script&lang=js&"
export * from "./time-since.vue?vue&type=script&lang=js&"
import style0 from "./time-since.vue?vue&type=style&index=0&id=536cdba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536cdba4",
  null
  
)

export default component.exports